module.exports = __webpack_public_path__ + "img/clase_cuatrojos.7818560f.webp";